export default __webpack_public_path__ + "static/autoplay-test-dark-7a31a8311a8317b7656de7ab6e7c4773.mp4";